// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__13iDk","detailsBorder":"styles_detailsBorder__Ey1l_"};